<template>
  <div>
    <!-- ContactoView -->
  </div>
</template>

<script>
export default {
  name: 'ContactoView'
}
</script>



// WEBPACK FOOTER //
// src/views/web/ContactoView.vue